



















import VueOptions from '@utils/VueOptions'

settings =
  name: "EventScheduleSelector"

  resources:
    event_schedules:
      resourceName: 'event_schedules'
      slug: 'event_schedules'
      params:
        brand_rep_id: ':brandRepId'

  vue:
    props: ['brandRepId', 'actions']

    data: ->
      selectedEventSchedule: null

    computed:
      isScheduleRoute: -> @$route.name.includes('EventSchedule')
      sessionEnabledForEventSchedule: -> !@actions?.onSelect?

      availableSchedules: ->
        scheduleId = @selectedEventSchedule?.id
        @event_schedules.filter((schedule) -> schedule.id isnt scheduleId)

    methods:
      initializeSelector: ->
        schedule = @selectedEventSchedule
        schedule = @$route.params.schedule if @$route?.params?.schedule?
        schedule ||= @event_schedules?[0]
        schedule ||= @getAppSession('selectedEventSchedule') if @sessionEnabledForEventSchedule
        @selectEventSchedule(schedule)

      navToSchedulePage: ->
        if (@currentMemberIsSuperUser())
          @$router.push({ name: 'EventScheduleShowPage', params: { eventScheduleId: @selectedEventSchedule.id } })
        else
          @$router.push({ name: 'EventScheduleListPage' })

      hiSelectScheduleId: (id) ->
        schedule = @lookupEventScheduleById(id)
        schedule ||= event_schedules[0]
        @selectEventSchedule(schedule)

      selectEventSchedule: (schedule) ->
        @selectedEventSchedule = schedule
        @actions?.onSelect?(schedule)
        @setAppSession('selectedEventSchedule', schedule) if @sessionEnabledForEventSchedule

      lookupEventScheduleById: (id) ->
        schedules = @event_schedules || []
        schedules.find((schedule) -> schedule.id is id)

      onLoadCollectionCompleted: (resourceKey) ->
        return unless resourceKey is 'event_schedules'
        @initializeSelector()

export default VueOptions.vue settings
